import { render, staticRenderFns } from "./error-content.vue?vue&type=template&id=28f23b35&"
import script from "./error-content.vue?vue&type=script&lang=js&"
export * from "./error-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports